<template>
  <div
    class="personal-accounts personal-accounts_open-menu"
    v-click-outside="onClickOutside"
  >
    <PersonalAccountItem/>
  </div>
</template>
<script>
import ClickOutside from 'vue-click-outside';
import PersonalAccountItem from './PersonalAccountItem.vue';
import { getters as lkPopupStateGetters } from '../../models/lk-popup-state';

export default {
  name: 'personalAccountPopup',
  components: {
    PersonalAccountItem,
  },
  props: {
    isOpen: Boolean,
    isEnabled: Boolean,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      clickOutsideCounter: 0,
    };
  },
  computed: {
    ...lkPopupStateGetters, // wasOpen
  },
  methods: {
    onClickOutside() {
      if (!this.isEnabled) {
        return;
      }

      // clickoutside срабатывает в тот момент, когда попап должен показаться (при клике на кнопку входа в ЛК),
      // и попап сразу скрывается. Чтобы избежать этого, пропустим первое срабатывание события clickoutside.
      // работает ли в IE?
      if (this.isOpen) {
        // eslint-disable-next-line no-plusplus
        if (this.clickOutsideCounter++ > 0) {
          this.clickOutsideCounter = 0;

          this.$emit('close');
        }
      }
    },
  },
  watch: {
    wasOpen(newVal) {
      if (!this.isEnabled) {
        this.clickOutsideCounter = +newVal;
      }
    },
  },
};
</script>

<style lang="scss">
  @import './PersonalAccountChoiceModal.scss';
</style>
